import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../view/Index.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: "/digital-map/",
  routes: [
    {
      path: "/",
      component: Home,
    },
  ],
});

export default router;
